import {
  ISurveyEvalResponse,
  ISurveyScalarResponseSummaries,
} from "src/api/types";

export interface IChampionsComparisonTableRow {
  coachScore: number;
  question: string;
  studentScore: number;
}

export const hasChampionsComparisonScores = (
  survey: ISurveyEvalResponse
): boolean => {
  return (
    survey.entryLevel >= 1 &&
    survey.entryLevel <= 4 &&
    !survey.isCoachSelfAssessmentOnly &&
    survey.responseCollectionEndDate !== null &&
    // survey.count.studentCount > 0 &&
    // survey.submitted === true &&
    (survey.championsComparison?.coachScores ?? []).length > 0
  );
};

export const getChampionsComparisonCoachScore = (
  survey: ISurveyEvalResponse,
  category: number,
  order: number,
  categoryIndex: number
): number | undefined => {
  if (!hasChampionsComparisonScores(survey)) {
    return undefined;
  }

  const coachScores = survey.championsComparison?.coachScores ?? [];
  const exactCoachScore = coachScores.find(
    (score) => score.category === category && score.order === order
  );
  const fallbackCoachScore = coachScores
    .filter((score) => score.category === category)
    .sort((a, b) => a.order - b.order)[categoryIndex];

  return exactCoachScore?.coachScore ?? fallbackCoachScore?.coachScore;
};

export const buildChampionsComparisonRows = (
  survey: ISurveyEvalResponse
): IChampionsComparisonTableRow[] => {
  if (!hasChampionsComparisonScores(survey)) {
    return [];
  }

  const rows: IChampionsComparisonTableRow[] = [];
  (["expectations", "warmth", "other"] as Array<
    keyof ISurveyScalarResponseSummaries
  >).forEach((key) => {
    survey.scaleResponseSummaries[key].averages.forEach((question, index) => {
      const coachScore = getChampionsComparisonCoachScore(
        survey,
        question.category,
        question.order,
        index
      );

      rows.push({
        coachScore: coachScore ?? -1,
        question: question.text,
        studentScore: question.studentScore,
      });
    });
  });

  return rows;
};



// WEBPACK FOOTER //
// ./src/features/director/pages/championsComparison.ts